export default "__VITE_ASSET__CKCBr6qZ__"